export default class DropShip {
	name = '';
	technician = '';
	address1 = '';
	address2 = '';
	city = '';
	state = '';
	country = '';
	zip = '';
	phone = '';
	email = '';
	stateAbbreviation = '';

	constructor(address) {
		if (address) {
			this.name = address.ShopName;
			this.technician = address.Technician;
			this.address1 = address.Address1;
			this.address2 = address.Address2;
			this.city = address.City;
			this.state = address.State;
			this.country = address.Country;
			this.zip = address.Zip;
			this.phone = address.Phone;
			this.email = address.Email;
			this.stateAbbreviation = address.Abbreviation;
		}
	}

	serialize(address) {
		return {
			ShopName: address.name,
			Technician: address.technician,
			Address1: address.address1,
			Address2: address.address2,
			City: address.city,
			State: address.state,
			Abbreviation: address.stateAbbreviation,
			Country: address.country,
			Zip: address.zip,
			Phone: address.phone,
			Email: address.email,
		};
	}
}



// WEBPACK FOOTER //
// ./src/api/models/DropShip.js